import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isNull } from "lodash";

import SiteTitle from "./../../../utils/SiteTitle/SiteTitle";
import EditAvatarAdmin from "./EditAvatarAdmin/EditAvatarAdmin";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import { setUserInfoAction } from "../../../redux/actions/userInfoActions/userInfoActions";
import { editInfoService } from "../../../services/userServices";
import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

const EditProfileAdmin = () => {
  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userInfo);
  const appConfigs = useSelector((state) => state.appConfigs);
  const introductionItems = appConfigs?.INTRODUCTION_CHOICES?.split("،");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [introduction, setIntroduction] = useState("");

  useEffect(() => {
    if (userInfo) {
      setFirstName(userInfo.first_name);
      setLastName(userInfo.last_name);
      setEmail(userInfo.email);
      setPhoneNumber(userInfo.mobile);
      setIntroduction(userInfo.introduction);
    }
  }, [userInfo]);

  // Handle Edit Info Method
  const handleEditInfo = async (event) => {
    event.preventDefault();

    const objData = {
      first_name: firstName,
      last_name: lastName,
      email,
      mobile: phoneNumber,
      ...(introduction && {
        introduction: +introduction,
      }),
    };

    if (!firstName) return toastErrorMessage("نام الزامی میباشد");
    if (!lastName) return toastErrorMessage("نام خانوادگی الزامی میباشد");

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editInfoService(objData);
      if (status === 200) {
        dispatch(setUserInfoAction());

        toastSuccessMessage("حساب کاربری با موفقیت ویرایش شد");
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <SiteTitle title="ویرایش پروفایل" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "ناحیه کاربری", type: "d" },
          { name: "ویرایش حساب کاربری", type: "a" },
        ]}
        title="ویرایش پروفایل"
      />

      <div className="card">
        <div className="card-body">
          <div>
            <EditAvatarAdmin />
          </div>

          <br />

          <form
            autoComplete="off"
            onSubmit={(e) => handleEditInfo(e)}
            className="mb-3"
          >
            <div className="row">
              {/* First Name */}
              <div className="col-6 mb-2">
                <label>نام</label>
                <input
                  type="text"
                  name="firstName"
                  className="form-control"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              {/* Last Name */}
              <div className="col-6 mb-2">
                <label>نام خانوادگی</label>
                <input
                  type="text"
                  name="lastName"
                  className="form-control"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
              {/* Email */}
              <div className="col-6 mb-2">
                <label>پست الکترونیک</label>
                <input
                  type="text"
                  name="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              {/* Phone Number */}
              <div className="col-6 mb-2">
                <label>شماره موبایل</label>
                <input
                  type="number"
                  name="phoneNumber"
                  className="form-control disabled bg-light"
                  disabled
                  value={phoneNumber}
                  // onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
              {/* Introduction */}
              <div className="col-6 mb-2">
                <label>نحوه آشنایی</label>
                <select
                  className="form-control"
                  onChange={(e) => setIntroduction(e.target.value)}
                  disabled={
                    userInfo.introduction >= 0 &&
                    !isNull(userInfo?.introduction)
                  }
                  value={introduction}
                >
                  <option value="" disabled hidden>
                    نحوه آشنایی خود را انتخاب کنید
                  </option>
                  {introductionItems?.map((_item, index) => (
                    <option key={index} value={index}>
                      {_item}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-12 mt-3">
                <button type="submit" className="btn btn-primary">
                  ویرایش حساب کاربری
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditProfileAdmin;
